import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Btn from '../../../../../../components/btn';
import {
  selectors,
  sliceKeys,
  actionCreators,
  acceptanceCreationSteps,
} from '../../../../model';

const { selectHasHouses } = selectors[sliceKeys.houses];
const { stepChanged } = actionCreators[sliceKeys.createPage];

const action = stepChanged(acceptanceCreationSteps.acceptanceSetup);

const ToAcceptanceSetup = () => {
  const hasHouses = useSelector(selectHasHouses);

  const dispatch = useDispatch();

  return (
    <Btn onClick={() => dispatch(action)} disabled={!hasHouses}>
      Сохранить и продолжить
    </Btn>
  );
};

export default ToAcceptanceSetup;
